

const TOKEN_KEY = 'token'

export function setToken(jwt) {
  window.localStorage.setItem(TOKEN_KEY, jwt)
}

export function getToken() {
  return window.localStorage.getItem(TOKEN_KEY)
}

export function isLoggedIn() {
  return getToken()
}

export function logout() {
  window.localStorage.removeItem(TOKEN_KEY)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js